import { Component, OnInit } from '@angular/core';
import { screenShortcut } from './shortcut.json';

@Component({
    selector: 'app-screen-shortcuts',
    templateUrl: './screen-shortcuts.component.html',
    styleUrls: ['./screen-shortcuts.component.scss'],
    standalone: false
})
export class ScreenShortcutsComponent implements OnInit {
  shortcuts: { key_name: string; screen_name: string; url: string; }[];

  constructor() { }

  ngOnInit(): void {
    this.shortcuts = screenShortcut;
  }

}
